import { PropertyState, DataPersonInfoState } from '../types/form.types';
import { DataPersonalInfoState } from './personalInfo.state';

export enum EnumActionsTypesPI {
  SET_DATA_PROPERTY = 'SET_PERSONAL_INFO_DATA_PROPERTY',
  SET_NAMES = 'SET_PERSONAL_INFO_NAMES',
  FETCH_REQUESTS = 'FETCH_REQUEST',
  FETCH_FAILURE = 'FETCH_FAILURE',
  FETCH_SUCCESS = 'FETCH_SUCCESS',
  SET_PERSON = 'SET_PERSON',
  BACK_INITIAL_STATE = 'BACK_INITIAL_STATE',
  SET_REDUX_STATE = 'SET_REDUX_STATE',
}

export interface IsLoadingInterface {
  isLoading: boolean;
}

export interface SetDataPropertyAction {
  type: EnumActionsTypesPI.SET_DATA_PROPERTY;
  payload: PropertyState;
}

export interface IsLoadingInterface {
  isLoading: boolean;
}

export interface FetchSuccess {
  type: typeof EnumActionsTypesPI.FETCH_SUCCESS;
  payload: IsLoadingInterface;
}

export interface FetchRequests {
  type: EnumActionsTypesPI.FETCH_REQUESTS;
  payload: IsLoadingInterface;
}

export interface SetPerson {
  type: EnumActionsTypesPI.SET_PERSON;
  payload: DataPersonInfoState;
}

export interface FetchFailure {
  type: typeof EnumActionsTypesPI.FETCH_FAILURE;
  payload: IsLoadingInterface;
}

export interface FetchRequests {
  type: EnumActionsTypesPI.FETCH_REQUESTS;
  payload: IsLoadingInterface;
}

export interface SetPerson {
  type: EnumActionsTypesPI.SET_PERSON;
  payload: DataPersonInfoState;
}

export interface BackInitialState {
  type: EnumActionsTypesPI.BACK_INITIAL_STATE;
}

export interface SetReduxState {
  type: EnumActionsTypesPI.SET_REDUX_STATE;
  payload: DataPersonalInfoState;
}

export type ActionsTypes =
  | SetDataPropertyAction
  | FetchFailure
  | FetchRequests
  | FetchSuccess
  | SetPerson
  | BackInitialState
  | SetReduxState;
